import { createFileRoute } from "@tanstack/react-router"
import { InvestStats } from "@/components/investStats/InvestStats.tsx"
import { PoolId } from "@/redux/poolSlice.ts"

export const Route = createFileRoute("/_mainLayout/revshare-pool-stats/$year/$month/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { year, month } = Route.useParams()
  return (
    <InvestStats poolId={{ code: 'kz', month: parseInt(month), year: parseInt(year) } as PoolId} />
  );
}
